<template>
  <tr class="cabinet__tbody-row">
    <td style="width: 20%">
      {{ idFormatted }}
    </td>
    <td style="width: 20%">
      {{ documentDate }}
    </td>
    <td style="width: 20%">
      {{ organizationName }}
    </td>
    <td style="width: 19%">
      {{ objectName }}
    </td>
    <td style="width: 19%">
      {{ status }}
    </td>
    <td>
      <ReceiptOrderTableTooltip :item="item" />
    </td>
  </tr>
</template>

<script>

import { dateFormat } from '@/utils/helpers';
import ReceiptOrderTableTooltip from '@/components/elements/ReceiptOrderTableTooltip';

export default {
  name: 'SupplyRequestListTableItem',
  components: { ReceiptOrderTableTooltip },
  props: {
    item: {
      type: Object,
    },
  },
  computed: {
    id() {
      return this.item.id;
    },
    idFormatted() {
      return this.item.id.toString().padStart(10, '0');
    },
    status() {
      return this.item.status;
    },
    documentDate() {
      return dateFormat(this.item.documentDate);
    },
    objectName() {
      return this.item.objectName;
    },
    organizationName() {
      return this.item.organizationName;
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.show-contract {
  color: transparent;
  display: block;
  content: '';
  margin: 0 5px;
}
</style>
